export const CaseStudiesSection: React.FC<{ data: any; theme: any }> = ({
  data,
  theme,
}) => {
  if (!data?.studies || data.studies.length === 0) return null;

  return (
    <section
      id="case-studies"
      className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 text-gray-900">
            {data.sectionTitle || "Success Stories"}
          </h2>
          {data.description && (
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              {data.description}
            </p>
          )}
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {[...data.studies]
            .sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0))
            .map((study: any, i: number) => (
              <div
                key={i}
                className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200 hover:shadow-2xl transition-shadow"
              >
                {study.caseStudyImageUrl && (
                  <div className="h-56 overflow-hidden bg-gray-100">
                    <img
                      src={study.caseStudyImageUrl}
                      alt={study.caseStudyHeading}
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}

                <div className="p-6 sm:p-8">
                  <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
                    {study.caseStudyHeading}
                  </h3>

                  {study.caseStudyDescription && (
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {study.caseStudyDescription}
                    </p>
                  )}

                  {study.caseStudyResults &&
                    study.caseStudyResults.length > 0 && (
                      <div className="mb-6 grid grid-cols-2 gap-4">
                        {study.caseStudyResults.map(
                          (result: any, ri: number) => (
                            <div
                              key={ri}
                              className="text-center p-4 rounded-xl border-2"
                              style={{
                                borderColor: theme?.primaryColor || "#10B981",
                                backgroundColor: `${theme?.primaryColor || "#10B981"}10`,
                              }}
                            >
                              <div
                                className="text-3xl sm:text-4xl font-bold mb-1"
                                style={{
                                  color: theme?.primaryColor || "#10B981",
                                }}
                              >
                                {result.value}
                              </div>
                              <div className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                                {result.metric}
                              </div>
                              {result.description && (
                                <div className="text-xs text-gray-500 mt-1">
                                  {result.description}
                                </div>
                              )}
                            </div>
                          ),
                        )}
                      </div>
                    )}

                  {(study.studentName || study.testimonial) && (
                    <div className="mt-6 pt-6 border-t border-gray-200">
                      {study.testimonial && (
                        <p className="text-gray-700 italic mb-4 leading-relaxed">
                          "{study.testimonial}"
                        </p>
                      )}
                      {study.studentName && (
                        <div className="flex items-center gap-3">
                          <div
                            className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold"
                            style={{
                              backgroundColor: theme?.primaryColor || "#10B981",
                            }}
                          >
                            {study.studentName.charAt(0)}
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">
                              {study.studentName}
                            </p>
                            {study.studentTitle && (
                              <p className="text-sm text-gray-500">
                                {study.studentTitle}
                              </p>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};
